export const environment = {
  domain: "https://armsdata-test.azurewebsites.net/",
  apiUrl: "https://app-armstracker-api-test.azurewebsites.net/",
  production: true,
};
